import { render, staticRenderFns } from "./TicketInformation.vue?vue&type=template&id=838076fc"
import script from "./TicketInformation.vue?vue&type=script&lang=js"
export * from "./TicketInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports